module.exports = __webpack_public_path__ + "static/media/door-closed.3981b51b.svg";